import React, { useEffect, useMemo, useState } from "react";
import SoftBadge from "modules/common/SoftBadge";
import { Button } from "react-bootstrap";
import PrescriptionTest from "modules/dashboards/feedback_form/PrescriptionTest";
import CardDiv from "modules/common/card-div/CardDiv";
import InterventionTrayaPrescription from "modules/dashboards/feedback_form/InterventionTrayaPrescription";
import InterventionPrescription from "modules/dashboards/feedback_form/InterventionPrescription";
import _ from "lodash";
import { useProductMapping } from "modules/dashboards/actionables/store";
import { isEmpty } from "lodash";
import { useClinicStore } from "./store";
import { toast } from "react-toastify";
import { Typography, Upload } from "antd";
const { Text } = Typography;
import { PlusOutlined } from "@ant-design/icons";
import imageCompression from "browser-image-compression";
import { Image } from "antd";

function PrescriptionCreationForm({
  caseId,
  setIsModalVisible,
  view,
  setView,
}) {
  const { productsData, fetchProducts } = useProductMapping();
  const {
    getPrescriptionData,
    viewPrescriptionData,
    clinicEditPrescription,
    clinicWritePrescription,
    uploadImagePres,
    clinicPresRes,
  } = useClinicStore();
  const [prescriptionStore, setPrescriptionStore] = useState([]);
  const [medicine, setMedicine] = useState({
    prescription: "",
    dosage: "",
    comment: "",
    external: true,
  });
  const [prescriptionStoreTraya, setPrescriptionStoreTraya] = useState([]);
  const [medicineTraya, setMedicineTraya] = useState({
    prescription: "",
    dosage: "",
    comment: "",
  });
  const [prescriptionStoreTest, setPrescriptionStoreTest] = useState([]);
  const [medicineTest, setMedicineTest] = useState({
    test: "",
  });
  const [fileList, setFileList] = useState([]);

  const prescriptionImage = useMemo(() => {
    return _.get(viewPrescriptionData, "[0].images", []);
  }, [viewPrescriptionData]);

  useEffect(() => {
    if (view) {
      getPrescriptionData(caseId);
    }
  }, [view]);

  useEffect(() => {
    if (!_.isEmpty(clinicPresRes) && fileList?.length) {
      const presId = _.get(clinicPresRes, "_id");
      const uploadImage = async () => await uploadFile(presId);
      uploadImage();
    }
  }, [clinicPresRes]);

  useEffect(() => {
    if (view && !isEmpty(viewPrescriptionData)) {
      const prescriptionData = _.get(
        viewPrescriptionData,
        "[0].prescription",
        []
      );
      const internalPrescription = [];
      const externalPrescription = [];
      const testPrescription = [];
      _.forEach(prescriptionData, (prescription) => {
        const prescriptionLength = Object.keys(prescription).length;
        if (prescriptionLength === 4) {
          externalPrescription.push(prescription);
        } else if (prescriptionLength >= 3) {
          internalPrescription.push(prescription);
        } else {
          testPrescription.push(prescription);
        }
      });
      setPrescriptionStore(externalPrescription);
      setPrescriptionStoreTraya(internalPrescription);
      setPrescriptionStoreTest(testPrescription);
    } else {
      setPrescriptionStore([]);
      setPrescriptionStoreTraya([]);
      setPrescriptionStoreTest([]);
    }
  }, [view, viewPrescriptionData]);

  useEffect(() => {
    isEmpty(productsData) && fetchProducts();
  }, []);

  const handleFakeRequest = ({ onSuccess }) => {
    return setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const handleFileChange = (info) => {
    setFileList(info.fileList);
  };

  const uploadFile = async (presId) => {
    const options = {
      maxSizeMB: 5,
      useWebWorker: true,
    };

    const imageDataArray = [];

    for (let image = 0; image < fileList?.length; image++) {
      const file = fileList[image];
      const type = fileList[image]?.type;
      let fileData = new FormData();
      let compressedFile = null;
      if (type !== "application/pdf") {
        compressedFile = await imageCompression(file.originFileObj, options);
      } else {
        compressedFile = file.originFileObj;
      }
      fileData.append("file", compressedFile, file.name);
      imageDataArray.push(fileData);
    }
    const uploadImage = imageDataArray?.map(async (item) => {
      return uploadImagePres(presId, item);
    });
    await Promise.all(uploadImage);
  };

  const handleSubmit = () => {
    const medicineData = _.groupBy(
      productsData,
      (product) => product.medicine.display_name
    );
    const newPrescriptionData = _.map(prescriptionStoreTraya, (item) => {
      const productDetail = medicineData[item.prescription][0];
      return {
        ...item,
        product_id: productDetail.product_id,
        product_price: productDetail.product_price,
        single_images: productDetail.single_images,
        cart_cdn_images: productDetail.cart_cdn_images,
        medicine_type: productDetail.medicine.type,
        mobile_image_path: productDetail.mobile_image_path,
        sku_hinglish_image: productDetail.sku_hinglish_image,
        sku_styled_image: productDetail.sku_styled_image,
        web_male_mobile: productDetail.web_male_mobile,
        web_mobile_screen_images: productDetail.web_mobile_screen_images,
      };
    });
    const prescriptionData = {
      case_id: caseId,
      prescription: [
        ...newPrescriptionData,
        ...prescriptionStore,
        ...prescriptionStoreTest,
      ],
    };
    if (view) {
      const prescriptionId = _.get(viewPrescriptionData, "[0]._id", []);
      clinicEditPrescription(prescriptionId, prescriptionData, toast);
      setView(false);
    } else {
      clinicWritePrescription(prescriptionData, toast);
    }
    setIsModalVisible(false);
  };

  return (
    <div className="d-flex flex-column gap-2">
      <CardDiv
        title={
          <div className="m-n2">
            <SoftBadge bg="info" className="me-2 border-bottom">
              <div className="fs-1">Traya Internal Prescription</div>
            </SoftBadge>
          </div>
        }
        component={
          <div className="m-n2">
            <InterventionTrayaPrescription
              prescriptionStoreTraya={prescriptionStoreTraya}
              setPrescriptionStoreTraya={setPrescriptionStoreTraya}
              medicineTraya={medicineTraya}
              setMedicineTraya={setMedicineTraya}
            />
          </div>
        }
      />
      <CardDiv
        title={
          <div className="m-n2">
            <SoftBadge bg="info" className="me-2 border-bottom">
              <div className="fs-1">External Prescription</div>
            </SoftBadge>
          </div>
        }
        component={
          <div className="m-n2">
            <InterventionPrescription
              prescriptionStore={prescriptionStore}
              setPrescriptionStore={setPrescriptionStore}
              medicine={medicine}
              setMedicine={setMedicine}
            />
          </div>
        }
      />
      <CardDiv
        title={
          <div className="m-n2">
            <SoftBadge bg="info" className="me-2 border-bottom">
              <div className="fs-1">Medical Tests</div>
            </SoftBadge>
          </div>
        }
        component={
          <div className="m-n2">
            <PrescriptionTest
              prescriptionStoreTest={prescriptionStoreTest}
              setPrescriptionStoreTest={setPrescriptionStoreTest}
              medicineTest={medicineTest}
              setMedicineTest={setMedicineTest}
            />
          </div>
        }
      />
      {!view && (
        <div className="my-2">
          <div className="mb-3">
            <Text>Upload Photo</Text>
            <Upload
              accept="image/png, image/jpeg, application/pdf"
              listType="picture-card"
              customRequest={handleFakeRequest}
              onChange={handleFileChange}
              onPreview={(file) => {
                if (typeof window.URL.createObjectURL === "function") {
                  const url = window.URL.createObjectURL(file.originFileObj);
                  window.open(url, "_blank").focus();
                }
              }}
            >
              <div className="flex flex-col gap-2">
                <PlusOutlined />
                <span>Upload</span>
              </div>
            </Upload>
          </div>
        </div>
      )}
      {view && prescriptionImage?.length && (
        <>
          <div className="p-2 border-bottom mb-2 fw-bold fs-1">
            Uploaded Image
          </div>
          <Image.PreviewGroup
            preview={{
              onChange: (current, prev) =>
                console.log(`current index: ${current}, prev index: ${prev}`),
            }}
          >
            <div className="d-flex flex-row gap-2">
              {_.map(prescriptionImage, (item, index) => {
                return <Image width={140} height={140} src={item} key={index} />;
              })}
            </div>
          </Image.PreviewGroup>
        </>
      )}
      <div className="text-end">
        <Button
          variant="info"
          className="w-25 text-center"
          onClick={handleSubmit}
        >
          Save Prescription
        </Button>
      </div>
    </div>
  );
}

export default PrescriptionCreationForm;
